export default __webpack_public_path__ + "static/media/person1Kalenday.ddb104a1.png";